import { isQueryParamEqualTo } from './url';

export const isEmailFlow = () => isQueryParamEqualTo('lps_flow', 'after_email_controller');